import { render, staticRenderFns } from "./booking_customer_list_tbn.vue?vue&type=template&id=b2226322&scoped=true&"
import script from "./booking_customer_list_tbn.vue?vue&type=script&lang=js&"
export * from "./booking_customer_list_tbn.vue?vue&type=script&lang=js&"
import style0 from "./booking_customer_list_tbn.vue?vue&type=style&index=0&id=b2226322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2226322",
  null
  
)

export default component.exports